// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3EPOu","content":"RecentSearches_content__3RVvd"};